import { NV, SCHEMATA } from "./konstanten.js";
import { locale, sprache } from "../i18n/index.js";

const jahrLabel = (jahr) => (jahr === NV || jahr == null ? "N.V." : String(jahr));


function normiert(schemaKey, wert) {
  const s = SCHEMATA[schemaKey];
  if (!s || wert == null) return null;
  return Math.max(0, Math.min(1, (wert - s.min) / (s.max - s.min)));
}


function wertFormat(schemaKey, wert) {
  const s = SCHEMATA[schemaKey];
  if (!s || wert == null) return "—";
  const z = wert.toLocaleString(locale(), { maximumFractionDigits: 2 });
  return schemaKey === "stars5" ? `${z} ★` : `${z}${s.kurz}`;
}


/* §3 ─ Fachlogik & Formatierung ───────────────────────────────── */

const fmtZahl = (n, stellen = 1) =>
  n == null ? "—" : n.toLocaleString(locale(), { maximumFractionDigits: stellen });


/* Währung samt Stellung des Zeichens der Sprache überlassen:
   „1.234 €" im Deutschen, „€1,234" im Englischen. */
const fmtEuro = (n) => {
  if (n == null) return "—";
  try {
    return n.toLocaleString(locale(), {
      style: "currency", currency: "EUR", maximumFractionDigits: 0,
    });
  } catch (e) {
    return n.toLocaleString(locale(), { maximumFractionDigits: 0 }) + " €";
  }
};


/* Alphabetische Sortierung folgt der eingestellten Sprache — im
   Spanischen etwa wird „ñ" anders einsortiert als im Deutschen. */
const sortDe = (a, b) => String(a.name || "").localeCompare(String(b.name || ""), sprache());


const parseZahl = (s) => {
  if (s === "" || s == null) return null;
  const n = parseFloat(String(s).replace(",", "."));
  return Number.isNaN(n) ? null : n;
};


const parseJahr = (s) => {
  if (s === "" || s == null) return null;
  const n = parseInt(String(s).trim(), 10);
  return Number.isNaN(n) || n < 1900 || n > 2100 ? null : n;
};


const uid = () =>
  (typeof crypto !== "undefined" && crypto.randomUUID)
    ? crypto.randomUUID()
    : "id-" + Math.random().toString(36).slice(2) + Date.now().toString(36);


const isoDatum = (d) => {
  const p = (x) => String(x).padStart(2, "0");
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
};


const deDatum = (iso) => {
  if (!iso) return "";
  const [j, m, t] = String(iso).split("-");
  if (!j || !m || !t) return String(iso);
  try {
    return new Date(Number(j), Number(m) - 1, Number(t)).toLocaleDateString(locale());
  } catch (e) {
    return `${t}.${m}.${j}`;
  }
};

/* Zeitstempel (ISO mit Uhrzeit) als Datum in der Sprache der
   Oberfläche — für Vorschläge und Protokoll. `deDatum` erwartet
   dagegen ein reines Datum „JJJJ-MM-TT“ und liest es ohne Zeitzone. */
const datumAusZeit = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? "" : d.toLocaleDateString(locale());
};

export { datumAusZeit, deDatum, fmtEuro, fmtZahl, isoDatum, jahrLabel, normiert, parseJahr, parseZahl, sortDe, uid, wertFormat };
